export default {
  pageSize: (state) => state.pageSize,
  searchTerm: (state) => state.searchTerm,
  filterOptions: (state) => state.filterOptions,
  filterBy: (state) => state.filterBy,
  sortDir: (state) => state.sortDir,
  orderBy: (state) => state.orderBy,
  dashboard: (state) => state.dashboard,
  dashboardTop: (state) => state.dashboardTop,
  adasRecords: (state) => state.adasRecords,
  counts: (state) => state.counts,
  topStats: (state) => state.topStats,
  evaluation: (state) => state.evaluation,
  failedVins: (state) => state.failedVins,
  startDate: (state) => state.startDate,
  endDate: (state) => state.endDate,
  firms: (state) => state.firms,
  allFirms: (state) => state.allFirms,
  log: (state) => state.log,
  logParameters: (state) => state.logParameters,
  original: (state) => state.original,
  analyzeView: (state) => state.analyzeView,
  analyzeViews: (state) => state.analyzeViews,
  rangeView: (state) => state.rangeView,
  rangeViews: (state) => state.rangeViews,
  clientReview: (state) => state.clientReview,
  clientInspections: (state) => state.clientInspections,
  decodeStats: (state) => state.decodeStats,
  clientBreakdown: (state) => state.clientBreakdown,
  bms: (state) => state.bms,
  fragmentation: (state) => state.fragmentation,
  missingIndexes: (state) => state.missingIndexes,
  aiLoading: (state) => state.aiLoading,
  aiResponse: (state) => state.aiResponse,
  quote: (state) => state.quote,
  predictive: (state) => state.predictive
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js